import { text_to_slug } from "../../../util/methods"

$(document).on("turbolinks:load", function () {
  var $saleCampaignForm = $(".js-saleCampaign-form")

  if ($saleCampaignForm.length > 0) {
    var $heroTrigger = $(".js-saleCampaign-heroTrigger")
    var $heroFields = $(".js-saleCampaign-heroFields")

    var $popularTrigger = $(".js-saleCampaign-popularTrigger")
    var $popularFields = $(".js-saleCampaign-popularFields")

    var $productsToggle = $(".js-saleCampaign-productsToggle")
    var $productsTarget = $(".js-saleCampaign-productsTarget")

    var $discount_type = $("#campaign_discount_type")
    toggleDiscountType($discount_type.val())

    $discount_type.on("change", function () {
      toggleDiscountType($(this).val())
    })

    updateProductsTarget()
    $productsToggle.on("change", updateProductsTarget)

    if ($heroTrigger.length > 0) {
      $heroTrigger.on("change", function () {
        if (this.checked) {
          $heroFields.show()
        } else {
          $heroFields.hide()
        }
      })

      if (!$heroTrigger[0].checked) {
        $heroFields.hide()
      }
    }

    if ($popularTrigger.length > 0) {
      $popularTrigger.on("change", function () {
        if (this.checked) {
          $popularFields.show()
        } else {
          $popularFields.hide()
        }
      })

      if (!$popularTrigger[0].checked) {
        $popularFields.hide()
      }
    }
  }

  // sluggify sale campaign title
  $("#sale_campaign_name").on("keyup", function () {
    $("#sale_campaign_slug")
      .val(text_to_slug($(this).val()))
      .trigger("input")
  })

  function updateProductsTarget() {
    if ($productsToggle.prop("checked")) {
      $productsTarget.hide()
      // remove any existing products
      $productsTarget.find(".remove_fields").click()
    } else {
      $productsTarget.show()
    }
  }

  function toggleDiscountType(val) {
    var $discount_flat_input = $("#sale_campaign_discount_flat")
    var $discount_percent_input = $("#sale_campaign_discount_percent")
    var $discount_flat_wrapper = $(".sale_campaign_discount_flat")
    var $discount_percent_wrapper = $(".sale_campaign_discount_percent")
    if (val == "flat") {
      $discount_flat_wrapper.show()
      $discount_percent_wrapper.hide()
      $discount_percent_input.val(0)
    } else {
      $discount_percent_wrapper.show()
      $discount_flat_wrapper.hide()
      $discount_flat_input.val(0)
    }
  }
})
